import React, { useState } from "react";
import {
  View,
  Text,
  Image,
  Dimensions,
  Animated,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
  FlatList,
  TextInput,
} from "react-native";
import {
  getAthletes,
  getcomAthletes,
  getCompetitionComponents,
} from "../../action/authAction";
import Header from "../../component/header";
import Background from "../../component/background";
import TabbarOption from "../../component/tabbarOption";
import { tokenState } from "../../reducer/recoil";
import { useRecoilValue } from "recoil";
import { useIsFocused } from "@react-navigation/native";
const { width, height } = Dimensions.get("window");
import { styles, stylesResponsive } from "./style";
import moment from "moment";

export default function index({ navigation, route }) {
  const token = useRecoilValue(tokenState);
  const [data, setData] = useState([]);
  const [country, setCountry] = useState([]);
  const [event, setEvent] = useState([]);
  const focux = useIsFocused();
  const [text, setText] = useState("");
  const [gender, setGender] = useState("");
  const [filEvent, setFilEvent] = useState("");
  const [fil, setFil] = useState("");

  console.log("data", data);

  React.useEffect(() => {
    apiCall();
    callCoutry();
  }, [focux]);

  async function apiCall() {
    const resposne = await getcomAthletes({
      token: token.token,
      competition_id: route.params.competition_id,
    });
    if (resposne) {
      if (resposne.result != null) {
        resposne.result.map((item, index) => {
          item?.map((el) => {
            setData((val) => {
              if (
                val?.filter(
                  (e) =>
                    e?.first_name == el?.first_name &&
                    e?.last_name == el?.last_name &&
                    e?.passport == el?.passport
                )?.length == 0
              ) {
                return val.concat(el);
              } else {
                return val;
              }
            });
          });
        });
      }
    }
  }

  async function callCoutry() {
    const response = await getCompetitionComponents(token.token);
    if (response) {
      setEvent((val) =>
        val
          .concat(
            route.params.events_female.map((item) => {
              return {
                label: item,
                value: item,
              };
            })
          )
          .concat(
            route.params.events_male.map((item) => {
              return {
                label: item,
                value: item,
              };
            })
          )
      );
      setCountry(
        response.getCountriesComponent.map((item) => {
          return { label: item.country_name, value: item.country_name };
        })
      );
    }
  }

  return (
    <View style={styles.container}>
      <Header
        backgroundColorCompetition="#FFFFFF"
        Admin
        navigation={navigation}
      />
      <ScrollView>
        <View>
          <Background
            navigation={navigation}
            Title={`COMPETITION/${route.params.name}/ATHLETE`}
            admin
          />
          {country.length && (
            <TabbarOption
              competition_id={route.params.competition_id}
              country={country}
              filterdata={event}
              onfilter={(val) => {
                if (val != "Countries") {
                  setFil(val);
                } else {
                  setFil("");
                }
              }}
              setGender={(val) => {
                if (val != "GENDER") {
                  setGender(val);
                } else {
                  setGender("");
                }
              }}
              onEvent={(val) => {
                setFilEvent(val);
                if (val != "All Events") {
                  setFilEvent(val);
                } else {
                  setFilEvent("");
                }
              }}
              CompeAthlete
              buttonTabbar
              onChangeText={(text) => setText(text)}
            />
          )}
          {width >= 1280 && (
            <View style={[styles.viewTopic]}>
              <Text
                numberOfLines={1}
                style={[
                  width < 1600 ? styles.textTitleRespons : styles.textTitle,
                  {
                    width: "10%",
                    // paddingRight: 40,
                    // backgroundColor: "#ff0000",
                  },
                ]}
              >
                {"IMAGE"}
              </Text>
              <Text
                numberOfLines={1}
                style={[
                  width < 1600 ? styles.textTitleRespons : styles.textTitle,
                  {
                    width: "8%",
                    paddingRight: 0,
                    // backgroundColor: "#f2f2f2",
                    marginHorizontal: -20,
                  },
                ]}
              >
                {"COUNTRY"}
              </Text>
              <Text
                numberOfLines={1}
                style={[
                  width < 1600 ? styles.textTitleRespons : styles.textTitle,
                ]}
              >
                {"FIRST NAME"}
              </Text>
              <Text
                numberOfLines={1}
                style={[
                  width < 1600 ? styles.textTitleRespons : styles.textTitle,
                ]}
              >
                {"LAST NAME"}
              </Text>
              <Text
                numberOfLines={1}
                style={[
                  width < 1600
                    ? styles.textTitleBirthRespons
                    : styles.textTitle,
                ]}
              >
                {"BIRTH"}
              </Text>
              <Text
                numberOfLines={1}
                style={[
                  width < 1600 ? styles.textTitleRespons : styles.textTitle,
                ]}
              >
                {"GENDER"}
              </Text>
              <Text
                numberOfLines={1}
                style={[
                  width < 1600 ? styles.textTitleRespons : styles.textTitle,
                ]}
              >
                {"EVENT"}
              </Text>
            </View>
          )}
          <FlatList
            data={data
              .filter((item) => {
                try {
                  return item.first_name
                    .toLowerCase()
                    .includes(text.toLowerCase());
                } catch (error) {
                  return false;
                }
              })
              .filter((item) => {
                try {
                  return item.Country.country_name
                    .toLowerCase()
                    .includes(fil.toLowerCase());
                } catch (error) {
                  return true;
                }
              })
              .filter(
                (item) =>
                  item.best_record.filter((item) =>
                    item.event.includes(filEvent)
                  ).length > 0
              )
              .filter((item) => {
                if (item.gender != null) {
                  return item.gender
                    .toLowerCase()
                    .includes(gender.toLowerCase());
                }
              })}
            scrollEnabled={width < 1280 ? true : false}
            renderItem={({ index, item }) => {
              item.Country == undefined
                ? (item.Country = {})
                : item.Country.country_name;
              return width >= 1280 ? (
                <View
                  style={[
                    styles.viewDetail,
                    {
                      backgroundColor: index % 2 == 0 ? "#CCE4FF" : "#FFFFFFbb",
                      borderTopWidth: index >= 1 ? 0 : 1,
                    },
                  ]}
                >
                  <View style={styles.sizeimg}>
                    <Image
                      resizeMode={"contain"}
                      style={styles.imgDetail}
                      source={{ uri: item.image_url }}
                    />
                    <Text
                      numberOfLines={1}
                      style={[
                        width < 1600
                          ? styles.textDetailRespons
                          : styles.textDetail,
                        styles.sizeCountry,
                        { alignSelf: "center", marginLeft: 50 },
                      ]}
                    >
                      {item.Country.country_name}
                    </Text>
                  </View>
                  <Text
                    numberOfLines={1}
                    style={[
                      width < 1600
                        ? styles.textDetailRespons
                        : styles.textDetail,
                    ]}
                  >
                    {item.first_name}
                  </Text>
                  <Text
                    numberOfLines={1}
                    style={[
                      width < 1600
                        ? styles.textDetailRespons
                        : styles.textDetail,
                    ]}
                  >
                    {item.last_name}
                  </Text>

                  <Text
                    numberOfLines={1}
                    style={[
                      width < 1600
                        ? styles.textBirthRespons
                        : styles.textDetail,
                    ]}
                  >
                    {moment(item.birth_date).format("DD-MM-YYYY")}
                  </Text>
                  <Text
                    numberOfLines={1}
                    style={[
                      width < 1600
                        ? styles.textDetailRespons
                        : styles.textDetail,
                      {
                        width: "10%",
                      },
                    ]}
                  >
                    {item.gender}
                  </Text>
                  <View style={{ width: "10%" }}>
                    {item.best_record.map((items) => {
                      return (
                        <Text
                          style={[
                            width < 1600
                              ? styles.textEventRespons
                              : styles.textEvent,
                          ]}
                        >
                          {items.event}
                        </Text>
                      );
                    })}
                  </View>
                </View>
              ) : (
                <View
                  style={[
                    stylesResponsive.viewDetail,
                    {
                      backgroundColor: index % 2 == 0 ? "#CCE4FF" : "#FFFFFFbb",
                      borderTopWidth: index >= 1 ? 0 : 1,
                    },
                  ]}
                >
                  <Image
                    resizeMode={"contain"}
                    style={styles.imgDetail}
                    source={{ uri: item.image_url }}
                  />
                  <View style={{ width: "60%" }}>
                    <Text
                      numberOfLines={1}
                      style={[stylesResponsive.textTitle, { marginTop: 0 }]}
                    >
                      COUNTRY
                    </Text>
                    <Text
                      numberOfLines={1}
                      style={[stylesResponsive.textDetail]}
                    >
                      {item.Country.country_name}
                    </Text>
                    <Text
                      numberOfLines={1}
                      style={[stylesResponsive.textTitle]}
                    >
                      FIRST NAME
                    </Text>
                    <Text
                      numberOfLines={1}
                      style={[stylesResponsive.textDetail]}
                    >
                      {item.first_name}
                    </Text>
                    <Text
                      numberOfLines={1}
                      style={[stylesResponsive.textTitle]}
                    >
                      LAST NAME
                    </Text>
                    <Text
                      numberOfLines={1}
                      style={[stylesResponsive.textDetail]}
                    >
                      {item.last_name}
                    </Text>
                    <Text
                      numberOfLines={1}
                      style={[stylesResponsive.textTitle]}
                    >
                      BIRTH
                    </Text>
                    <Text
                      numberOfLines={1}
                      style={[stylesResponsive.textDetail]}
                    >
                      {moment(item.birth_date).format("DD-MM-YYYY")}
                    </Text>
                    <Text
                      numberOfLines={1}
                      style={[stylesResponsive.textTitle]}
                    >
                      GENDER
                    </Text>
                    <Text
                      numberOfLines={1}
                      style={[stylesResponsive.textDetail]}
                    >
                      {item.gender}
                    </Text>
                    {item.best_record.length > 0 && (
                      <Text
                        numberOfLines={1}
                        style={[stylesResponsive.textTitle]}
                      >
                        {"EVENT"}
                      </Text>
                    )}
                    {item.best_record.map((items) => {
                      return (
                        <Text style={[stylesResponsive.textDetail]}>
                          {items.event}
                        </Text>
                      );
                    })}
                  </View>
                </View>
              );
            }}
          />
        </View>
      </ScrollView>
    </View>
  );
}
